import { Text, VStack } from '@chakra-ui/react'

import { tv } from '../model/board-layout'
import {
    BOARD_NOT_FOUND_STATE_TEXTS,
    type BoardNotFoundStateVariant,
} from '../model/board-not-found-state'

interface BoardNotFoundStateProps {
    variant: BoardNotFoundStateVariant
}

export const BoardNotFoundState = ({ variant }: BoardNotFoundStateProps) => {
    const { title, description } = BOARD_NOT_FOUND_STATE_TEXTS[variant]

    return (
        <VStack
            alignItems='center'
            bg='#f4f4f5'
            color='#212121'
            gap={tv(24)}
            h='100dvh'
            justifyContent='center'
            px={tv(60)}
            w='full'
        >
            <Text fontSize={tv(64)} fontWeight='800' textAlign='center'>
                {title}
            </Text>
            <Text color='#71717a' fontSize={tv(36)} fontWeight='600' textAlign='center'>
                {description}
            </Text>
        </VStack>
    )
}
